import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {map, Observable} from 'rxjs';
import { LocationCollection } from '../location-collections';
import { LocationCollectionsService } from '../location-collections.service';

export const EditLocationCollectionResolver: ResolveFn<LocationCollection[]> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<LocationCollection[]> => {
    const locationCollectionsService: LocationCollectionsService = inject(LocationCollectionsService);
    return locationCollectionsService.get(route.params['id']);
}
